/**
 * Logger utility that respects the VITE_ENABLE_LOGS environment variable
 * Set VITE_ENABLE_LOGS=false in .env to disable all logs in production
 * 
 * Works with both Vite (import.meta.env) and Next.js (process.env)
 */

const isLoggingEnabled = (): boolean => {
  // Vite environment
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_ENABLE_LOGS !== 'false';
  }
  // Next.js environment (server-side or build time)
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NEXT_PUBLIC_ENABLE_LOGS !== 'false';
  }
  // Default: enable logging
  return true;
};

export const logger = {
  log: (...args: any[]) => {
    if (isLoggingEnabled()) {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isLoggingEnabled()) {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isLoggingEnabled()) {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isLoggingEnabled()) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isLoggingEnabled()) {
      console.debug(...args);
    }
  },
};

